// Copyright (c) 2026 Riddle, LLC. All rights reserved.
// Author: Ray Harris

import { useEffect } from "react";
import { FeatureFlagsProvider } from "../context/FeatureFlagsContext";
import { ConnectionCallbackPage } from "../features/integrations/pages/ConnectionCallbackPage";
import { AppRoutes } from "../router/AppRoutes";
import { useCurrentRoute } from "../router/navigation";
import { connectionCallbackConnector } from "../utils/connectorCallback";
import { relayOAuthResultFromPopup } from "../utils/oauthPopup";
import { AppShellLayout } from "./AppShellLayout";
import { OnboardingRedirect } from "./OnboardingRedirect";
import { ProtectedRoute } from "./ProtectedRoute";
import { PublicLoginRoute } from "./PublicLoginRoute";
import { SubscriptionGate } from "./SubscriptionGate";

export function AppRouter() {
  const route = useCurrentRoute();

  useEffect(() => {
    relayOAuthResultFromPopup();
  }, []);

  if (route.key === "login") {
    const callbackConnector = connectionCallbackConnector(window.location.pathname);
    return callbackConnector === null ? (
      <PublicLoginRoute />
    ) : (
      <ConnectionCallbackPage connector={callbackConnector} />
    );
  }

  return (
    <ProtectedRoute>
      <FeatureFlagsProvider>
        <SubscriptionGate>
          <OnboardingRedirect route={route}>
            <AppShellLayout route={route}>
              <AppRoutes route={route} isAuthenticated />
            </AppShellLayout>
          </OnboardingRedirect>
        </SubscriptionGate>
      </FeatureFlagsProvider>
    </ProtectedRoute>
  );
}
